import { render } from "./TeamDialog.vue?vue&type=template&id=795a9588&scoped=true"
import script from "./TeamDialog.vue?vue&type=script&lang=js"
export * from "./TeamDialog.vue?vue&type=script&lang=js"

import "./TeamDialog.vue?vue&type=style&index=0&id=795a9588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795a9588"]])

export default __exports__